import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';


class BusyIntegrationServices {
  // get all the busy connections
  getBusyConnections = async (orgId) => {
    let url = `${Constants.BUSY_CONNECTIONS}`;
    if (orgId) url += `?org_id=${orgId}&`;
    const getBusyConnections = await Helpers.get({
      url,
    });
    return getBusyConnections;
  }

  // connect to busy
  connectToBusy = async (payload) => {
    const url = `${Constants.BUSY_CONNECTIONS}`;
    const connectToBusy = await Helpers.post({
      url,
      data: payload,
    });
    return connectToBusy;
  }

  // delete busy connection
  deleteBusyConnection = async (payload) => {
    const url = `${Constants.BUSY_CONNECTIONS}`;
    const deleteBusyConnection = await Helpers.delete({
      url,
      data: payload,
    });
    return deleteBusyConnection;
  }

  // sync busy product
  syncProduct = async (payload) => {
    const url = `${Constants.IMPORT_BUSY_PRODUCTS}`;
    const syncProduct = await Helpers.post({
      url,
      data: payload,
    });
    return syncProduct;
  }

  // sync busy customer
  syncVendor = async (payload) => {
    const url = `${Constants.IMPORT_BUSY_VENDORS}`;
    const syncVendor = await Helpers.post({
      url,
      data: payload,
    });
    return syncVendor;
  }

  // refresh busy connection
  refreshBusyConnection = async (payload) => {
    const url = `${Constants.BUSY_CONNECTIONS}/refresh`;
    const refreshBusyConnection = await Helpers.post({
      url,
      data: payload,
    });
    return refreshBusyConnection;
  }

  // Busy Location connection
  connectToBusyLocation = async (payload) => {
    const url = `${Constants.BUSY_CONNECTIONS}`;
    const connectToBusyLocation = await Helpers.put({
      url,
      data: payload,
    });
    return connectToBusyLocation;
  }

  // push grn to busy
  pushGrnToBusy = async (payload) => {
    const url = `${Constants.PUSH_GRN_TO_BUSY}`;
    const pushGrnToBusy = await Helpers.post({
      url,
      data: payload,
    });
    return pushGrnToBusy;
  }

  // push invoice to busy
  pushInvoiceToBusy = async (payload) => {
    const url = `${Constants.PUSH_INVOICE_TO_BUSY}`;
    const pushInvoiceToBusy = await Helpers.post({
      url,
      data: payload,
    });
    return pushInvoiceToBusy;
  }
  // push expense to busy

  pushExpenseToBusy = async (payload) => {
    const url = `${Constants.PUSH_EXPENSE_TO_BUSY}`;
    const pushExpenseToBusy = await Helpers.post({
      url,
      data: payload,
    });
    return pushExpenseToBusy;
  }

  // push Credit note to busy
  pushCreditNoteToBusy = async (payload) => {
    const url = `${Constants.PUSH_CREDIT_NOTE_TO_BUSY}`;
    const pushCreditNoteToBusy = await Helpers.post({
      url,
      data: payload,
    });
    return pushCreditNoteToBusy;
  }

  // push Debit note to busy
  pushDebitNoteToBusy = async (payload) => {
    const url = `${Constants.PUSH_DEBIT_NOTE_TO_BUSY}`;
    const pushDebitNoteToBusy = await Helpers.post({
      url,
      data: payload,
    });
    return pushDebitNoteToBusy;
  }
}

export default new BusyIntegrationServices();
